module.exports = __webpack_public_path__ + "static/team-29-198e44b1e1e017af098d407e9d578913.jpg";